import create from 'zustand';
import produce from 'immer';

import DayJs from 'utils/Dayjs';

const STUDENT_COURSE_INITIAL = {
	grades: [],
	active: []
};

export const useStudentCourseStore = create(set => ({
	...STUDENT_COURSE_INITIAL,

	// Initialize student's grade state
	onInit: ({ grades, courses }) => set(produce(state => {
		// Get today's date
		const today = DayJs();

		state.grades = grades?.map(grade => {
			// Find current grade's courses
			const current = courses?.filter(c => c.gradeId === grade.id);

			// Create months from courses
			const months = current?.reduce((segments, course) => {
				const month = DayJs(course.startDate).format('MMMM');
				if (segments.includes(month)) return segments;
				return [...segments, month];
			}, []);

			// Return grade with splitted months
			return {
				...grade,
				courses: current,
				months: months?.map(segment => ({
					title: segment,
					courses: courses?.filter(c => DayJs(c.startDate).format('MMMM') === segment && c.gradeId === grade.id)
				}))
			};
		});

		// Map selected data by grades -> courses
		// state.grades = grades?.map(grade => ({
		// 	...grade,
		// 	courses: courses?.filter(c => c.gradeId === grade.id),
		// 	segments: courses?.reduce((segments, course) => {
		// 		if (course.gradeId === grade.id && segments.includes(course.startDate)) return [...segments, course.startDate];
		// 		return segments;
		// 	}, [])
		// }));

		// Map active courses
		state.active = courses?.filter(course => {
			return DayJs(course.startDate).isBefore(today) && DayJs(course.endDate).isAfter(today);
		});
	})),

	// Reset store to initial state
	onReset: () => set({
		...STUDENT_COURSE_INITIAL
	})
}));